<template>
  <div id="viewBox" ref="viewApp">
    <div
      class="buyCrypto_iframe_view"
      :class="{ buyCrypto_iframe_view_pc: logoState }"
    >
      <!-- :class="{'buyCrypto_iframe_view_pc': logoState}" -->
      <div
        id="App"
        :class="{ App_pc: logoState }"
        :style="{ width: shadowPadding ? '100%' : logoState ? '86.4%' : '89%' }"
      >
        <!-- ,'shadow-view': shadowPadding -->
        <!-- 导航栏 -->
        <tab
          ref="viewTab"
          :style="{
            paddingLeft: shadowPadding ? (logoState ? '6.5%' : '5.5%') : 0,
            paddingRight: shadowPadding ? (logoState ? '5.5%' : '5.5%') : 0,
          }"
        />
        <!--  :class="{'viewTab-padding': shadowPadding}" -->
        <!-- 页面内容 -->
        <div
          class="contentView"
          ref="routerView_box"
          :style="{
            paddingLeft: shadowPadding ? (logoState ? '6.5%' : '5.5%') : 0,
            paddingRight: shadowPadding ? (logoState ? '5.5%' : '5.5%') : 0,
          }"
        >
          <!--  :class="{'contentView-padding': shadowPadding}" -->
          <div
            class="routerView_box"
            v-show="routerViewState"
            ref="routerView_boxRef"
          >
            <div class="routerView" @scroll="handleScroll">
              <keep-alive class="keepAlive" :exclude="keepAlive">
                <router-view ref="routerView" />
              </keep-alive>
            </div>
            <!-- go down tips icon -->
            <transition>
              <div
                class="downTips-icon"
                v-if="goDownTips_state"
                @click="goDown"
              >
                <img src="@/assets/images/icons/downIcon.svg" alt="" />
              </div>
            </transition>
          </div>
          <!-- 菜单栏 -->
          <routerMenu v-if="!routerViewState" />
          <!-- 语言切换 -->
          <Language v-if="languageIsShow" />
          <!-- 买币 - 确认支付后查询支付状态提示框、泰铢支付确认跳转弹框 -->
          <QueryOrderStatusTips :buyOrderStatus="BuyTimeOut" v-if="tipsState" />
        </div>
      </div>

      <!-- 版本号 -->
      <!--      <span class="version">V: {{ version }}</span>-->
      <!-- 账号风险提示无法进行下一步 -->
      <!-- <div class="kycToast" v-show="AccountisShow">
        <div>
          <img src="@/assets/images/kycDisable.png" alt="">
            <div>
           {{ $t('nav.accountTraded') }}
            </div>
          <div @click="goHome">{{ $t('nav.Confirm') }}</div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import common from "./utils/common";
import remSize from "./utils/remSize";
import { mapState } from "vuex";
import { debounce } from "@/utils";

export default {
  name: "App",
  components: {
    routerMenu: () => import("./components/routerMenu"),
    QueryOrderStatusTips: () => import("./components/QueryOrderStatusTips"),
    Language: () => import("./components/Language.vue"),
    tab: () => import("./components/navigationBar"),
  },
  data() {
    return {
      routerViewState: true, //菜单和路由页面展示状态1

      logoState: true, //pc phone展示不同logo状态

      version: "", //版本号

      // AccountisShow: false, //风险账号公共组件状态

      tipsState: false, //二次确认通用弹框
      BuyTimeOut: "", //二次确认框展示信息类型

      goDownTips_state: false,
      scrollTimeDown: null,
    };
  },
  computed: {
    //路由是否需要缓存状态
    keepAlive() {
      let keepAliveName = "";
      let keepAliveList = this.$router.options.routes.filter((item) => {
        return !item.meta.keepAlive;
      });
      keepAliveList.forEach((item) => {
        keepAliveName = item.name + "," + keepAliveName;
      });
      return keepAliveName;
    },
    //不同页面设置不同padding
    shadowPadding() {
      return this.$route.path === "/paymentMethod" ? true : false;
    },
    //语言组件展示状态
    ...mapState("public", {
      languageIsShow: (state) => state.languageIsShow,
    }),
  },
  watch: {
    routerViewState(newVal) {
      //存储菜单和路由页面展示状态
      this.$store.commit("public/set_menuState", newVal);
    },
  },
  mounted() {
    this.setLanguage();
    console.log(
      `%c version %c ${require("../package.json").version} `,
      "background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff",
      "background:#41b883 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff",
    );
    // 窗口滚动监听
    window.addEventListener("scroll", this.handleScroll(this, self), true);

    this.obtainWidth();
    let innerHight =
      document.documentElement.clientHeight || document.body.clientHeight;
    let innerWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    window.addEventListener("resize", () => {
      if (innerWidth < 791) this.$refs.viewApp.style.height = innerHight + "px";
      else return false;
    });
    //Vuex store data
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store")),
        ),
      );
    }

    //api商户进入关闭当前浏览器清空商户登陆信息
    let beginTime = 0; //开始时间
    let differTime = 0; //时间差
    window.onunload = function () {
      differTime = new Date().getTime() - beginTime;
      let merchantInfo = JSON.parse(sessionStorage.getItem("merchantInfo"));
      if (differTime <= 1 && merchantInfo && merchantInfo.type === "api") {
        window.localStorage.getItem("token")
          ? window.localStorage.removeItem("token")
          : "";
        window.localStorage.getItem("token")
          ? window.localStorage.removeItem("sign")
          : "";
        window.localStorage.getItem("token")
          ? window.localStorage.removeItem("email")
          : "";
        window.localStorage.getItem("token")
          ? window.localStorage.removeItem("fin_token")
          : "";
        window.localStorage.getItem("token")
          ? window.localStorage.removeItem("login_email")
          : "";
        window.localStorage.getItem("token")
          ? window.localStorage.removeItem("userId")
          : "";
        window.localStorage.getItem("token")
          ? window.localStorage.removeItem("fingerprint_id")
          : "";
        window.localStorage.getItem("token")
          ? window.localStorage.removeItem("userNo")
          : "";
      }
    };

    //pagehide防止移动端beforeunload不能触发
    window.addEventListener("pagehide", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
    window.addEventListener("beforeunload", () => {
      beginTime = new Date().getTime();
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  methods: {
    // 默认语言
    setLanguage() {
      var JsSrc = (
        navigator.language || navigator.browserLanguage
      ).toLowerCase();
      var lang = "en-US";
      if (JsSrc.indexOf("en") >= 0) {
        lang = "en-US";
      } else if (JsSrc.indexOf("zh") >= 0) {
        lang = "zh-HK";
      } else if (JsSrc.indexOf("ko") >= 0) {
        lang = "ko";
      } else if (JsSrc.indexOf("es") >= 0) {
        lang = "es";
      }
      lang = sessionStorage.getItem("language") || lang;
      sessionStorage.setItem("language", lang);
      this.$i18n.locale = lang;
    },
    //动态获取屏幕大小计算rem
    obtainWidth() {
      this.version = require("../package.json").version;
      this.changeRem(document.body.clientWidth);
      window.onresize = () => {
        return (() => {
          this.changeRem(document.body.clientWidth);
        })();
      };
    },
    changeRem(width) {
      setTimeout(() => {
        if (width < 791) {
          //991
          common.uiSize = 375;
          common.equipmentEnd = "phone";
          remSize();
          this.logoState = false;
          this.$store.commit("public/set_isPcAndPhone", "phone");
          return;
        }
        common.uiSize = width + 100;
        common.equipmentEnd = "pc";
        remSize();
        this.logoState = true;
        this.$store.commit("public/set_isPcAndPhone", "pc");
      });
    },

    // goHome(){
    //   // this.AccountisShow = false
    //   if(this.$route.path === '/' && this.languageIsShow === true){
    //     this.$children[1].menuState = false;
    //     this.$store.commit("public/set_languageIsShow",false);
    //     return;
    //   }
    //   if(this.$route.path === '/'){
    //     this.$children[1].menuState = false;
    //     return;
    //   }
    //   if(this.$route.path !== '/' && this.routerViewState === false){
    //     this.routerViewState = true
    //     this.$router.push('/');
    //     return
    //   }
    //   this.$router.push('/');
    // },

    //监听滚动高度展示向下滚动按钮
    handleScroll() {},
    // handleScroll:debounce(function (val,self){
    //   console.log(val,"----val",self)
    //   if(this.$route.meta.type !== 'confirmOrder')return
    //
    //   window.clearTimeout(this.scrollTimeDown);
    //   this.scrollTimeDown = null;
    //
    //   //判断内容是否在可以范围内
    //   if(val.target.scrollHeight > this.$refs.routerView_boxRef.offsetHeight){
    //     this.goDownTips_state = true;
    //   }
    //
    //   //滑动判断是否滚动到底部
    //   setTimeout(()=>{
    //     if(val.target.scrollHeight - val.target.scrollTop < val.target.offsetHeight){
    //       this.goDownTips_state = false;
    //     }else{
    //       this.goDownTips_state = false;
    //       window.clearTimeout(this.scrollTimeDown);
    //       this.scrollTimeDown = null;
    //       this.scrollTimeDown = setTimeout(()=>{
    //         this.goDownTips_state = true;
    //       },1000)
    //     }
    //   },200)
    // },500),
    //滚动到底部
    goDown() {
      setTimeout(() => {
        this.$refs.routerView.$el.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "end",
        });
        this.goDownTips_state = false;
      });
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/app.scss"></style>
